export default __webpack_public_path__ + "static/media/certidao02.67a2d203.png";